import React from "react";
import Navbar from "../components/Navbar";
import { IoMdCheckmark } from "react-icons/io";
import Footer from "../components/Footer";

const Services = () => {
  return (
    <>
      <Navbar />
      <div className="bg-white text-gray-900 md:pt-30 pt-30">
        <main className="max-w-6xl mx-auto p-4 md:p-6">
          <div className="text-start py-10 md:py-20 ">
            <p className="text-2xl mb-6 font-light text-center md:text-start">
              Solar Solutions for Every Need
            </p>
            <h2 className="text-6xl md:text-7xl font-black text-[#039147] mb-6 text-center md:text-start">
              Powering India's Future
            </h2>
            <p className="text-4xl md:text-6xl text-[#FFCC00] font-semibold text-center md:text-start">
              One Rooftop at a Time
            </p>
          </div>

          <section className="mt-12">
            <h3 className="text-2xl md:text-3xl font-medium text-center mb-10 md:mb-20">
              Residential Solar Solutions
            </h3>
            <div className="flex flex-col-reverse md:flex-row mt-6 gap-6 ">
              <div className="w-full md:w-1/2">
                <p className="text-xl  text-center md:text-start">No More Load Shedding Woes!</p>
                <h4 className="font-semibold text-2xl md:text-3xl text-[#039147]  text-center md:text-start">
                  Power Your Home 24/7
                </h4>
                <div className="flex flex-wrap gap-2 mt-5 mb-5 md:items-start items-center justify-center md:justify-start">
                  <p className="border border-gray-400 rounded-full px-3 py-1 text-gray-500 text-sm">
                    🏠 Apartments (1BHK to 4BHK)
                  </p>
                  <p className="border border-gray-400 rounded-full px-3 py-1 text-gray-500 text-sm">
                    🏡 Independent Villas
                  </p>
                  <p className="border border-gray-400 rounded-full px-3 py-1 text-gray-500 text-sm">
                    🏘️ Gated Communities
                  </p>
                </div>

                <div className="flex flex-col space-y-4">
                  <div className="flex items-center space-x-3">
                    <IoMdCheckmark className="text-[#039147]" />
                    <div>
                      <p className="font-medium">Uninterrupted Power</p>
                      <p className="text-gray-600 text-sm md:text-base">
                        Solar + Battery Backup to keep lights, fans, and ACs running during outages.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-3">
                    <IoMdCheckmark className="text-[#039147]" />
                    <div>
                      <p className="font-medium">
                        Custom Designs ( Minimum 100 sq.ft area )
                      </p>
                      <p className="text-gray-600 text-sm md:text-base">
                        Systems tailored for small terraces (100 sq.ft) to large villas (1,000+ sq.ft).
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-3">
                    <IoMdCheckmark className="text-[#039147]" />
                    <div>
                      <p className="font-medium">Affordable EMI</p>
                      <p className="text-gray-600 text-sm md:text-base">
                        ₹0 Down Payment, starting at ₹4,999/month (5-year tenure)
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-3">
                    <IoMdCheckmark className="text-[#039147]" />
                    <div>
                      <p className="font-medium">Weatherproof Tech</p>
                      <p className="text-gray-600 text-sm md:text-base">
                        Panels tested for Mumbai monsoons, Delhi dust storms, and Chennai humidity.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2 flex justify-center">
                <img
                  src="/images/Residential.png"
                  alt="Residential Solar"
                  className="w-full h-auto object-cover rounded-lg shadow-md"
                />
              </div>
            </div>
          </section>

          <section className="mt-12 mb-12">
            <h3 className="text-2xl md:text-3xl font-medium text-center mb-10 md:mb-20">
              Commercial Solar Solutions
            </h3>
            <div className="flex flex-col-reverse md:flex-row-reverse mt-6 gap-6">
              <div className="w-full md:w-1/2">
                <p className="text-xl text-center md:text-start">Save ₹5+ Lakh/Year!</p>
                <h4 className="font-semibold text-2xl md:text-3xl text-[#039147] text-center md:text-start">
                  Slash Business Electricity Bills by 50%
                </h4>
                <div className="flex flex-wrap md:items-start items-center justify-center md:justify-start gap-2 mt-5 mb-5">
                  <p className="border border-gray-400 rounded-full px-3 py-1 text-gray-500 text-sm">
                    🏭 Factories
                  </p>
                  <p className="border border-gray-400 rounded-full px-3 py-1 text-gray-500 text-sm">
                    🏬 Offices
                  </p>
                  <p className="border border-gray-400 rounded-full px-3 py-1 text-gray-500 text-sm">
                    🏨 Hotels
                  </p>
                  <p className="border border-gray-400 rounded-full px-3 py-1 text-gray-500 text-sm">
                    🛍️ Retail Stores
                  </p>
                  <p className="border border-gray-400 rounded-full px-3 py-1 text-gray-500 text-sm">
                    🏫 Schools
                  </p>
                </div>

                <div className="flex flex-col space-y-4">
                  <div className="flex items-center space-x-3">
                    <IoMdCheckmark className="text-[#039147]" />
                    <div>
                      <p className="font-medium">Tax Savings</p>
                      <p className="text-gray-600 text-sm md:text-base">
                        Claim 40% accelerated depreciation (Income Tax Act).
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-3">
                    <IoMdCheckmark className="text-[#039147]" />
                    <div>
                      <p className="font-medium">ROI in 3–4 Years</p>
                      <p className="text-gray-600 text-sm md:text-base">
                        with 25+ years of free power
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-3">
                    <IoMdCheckmark className="text-[#039147]" />
                    <div>
                      <p className="font-medium">Zero Downtime</p>
                      <p className="text-gray-600 text-sm md:text-base">
                        Hybrid systems with grid + battery backup.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-3">
                    <IoMdCheckmark className="text-[#039147]" />
                    <div>
                      <p className="font-medium">Weatherproof Tech</p>
                      <p className="text-gray-600 text-sm md:text-base">
                        Panels tested for Mumbai monsoons, Delhi dust storms, and Chennai humidity.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2 flex justify-center">
                <img
                  src="/images/Commercial.png"
                  alt="Commercial Solar"
                  className="w-full h-auto object-cover rounded-lg shadow-md"
                />
              </div>
            </div>
          </section>

          <section className="mt-12 mb-12">
            <div className="flex flex-col-reverse  md:flex-row mt-6 gap-6 items-center justify-between">
              <div className="w-full md:w-1/2">
                <p className="text-gray-600 text-center md:text-start">
                  For shops/offices with stable grid supply.
                </p>
                <h4 className="font-semibold text-2xl md:text-4xl text-[#039147] text-center md:text-start">
                  On-Grid Solutions
                </h4>

                <div className="flex flex-col space-y-4 mt-10">
                  <div className="flex items-center space-x-3">
                    <IoMdCheckmark className="text-[#039147]" />
                    <p className="text-gray-600 text-sm md:text-base">
                      Excess electricity sent back to the grid can earn you credits, further offsetting your energy costs.
                    </p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <IoMdCheckmark className="text-[#039147]" />
                    <p className="text-gray-600 text-sm md:text-base">
                      Excess electricity sent back to the grid can earn you credits, further offsetting your energy costs.
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2 flex justify-center">
                <img
                  src="/images/ongrid.png"
                  alt="On-Grid Solar"
                  className="w-full h-auto object-cover rounded-lg shadow-md"
                />
              </div>
            </div>
          </section>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default Services;
